import React from 'react';
import {
  LineChart, Line, Tooltip, ResponsiveContainer, ReferenceLine,
} from 'recharts';

// Pecinhas de UI compartilhadas entre Competition.jsx (Arena legada, 18 bots)
// e Brains.jsx (Fase 2, cerebros com pool unico) -- extraidas quando a
// segunda tela precisou do mesmo visual, em vez de duplicar.

export const card = { background: '#1e293b', borderRadius: 12, padding: 24, marginBottom: 20 };

export function RankBadge({ rank }) {
  const medals = { 1: '🥇', 2: '🥈', 3: '🥉' };
  return <span style={{ fontSize: 22 }}>{medals[rank] || `#${rank}`}</span>;
}

export function PnlCell({ value, size = 14 }) {
  const color = value >= 0 ? '#34d399' : '#f87171';
  return (
    <span style={{ color, fontWeight: 700, fontSize: size }}>
      {value >= 0 ? '+' : ''}{value?.toFixed(2)}%
    </span>
  );
}

export const INTERVAL_COLORS = {
  '1m': '#e879f9',
  '5m': '#34d399',
  '15m': '#38bdf8',
  '30m': '#60a5fa',
  '1h': '#a78bfa',
  '4h': '#fbbf24',
  '1d': '#f97316',
};

// "Tamagotchi" barato: humor derivado do desempenho recente (backend calcula
// em mood.py), sem arte nova -- so um emoji + cor sobre o que ja existe.
export const MOODS = {
  on_fire: { emoji: '🔥', label: 'Em chamas', color: '#fb923c' },
  happy:   { emoji: '😊', label: 'Feliz',      color: '#34d399' },
  neutral: { emoji: '😐', label: 'Neutro',     color: '#94a3b8' },
  sad:     { emoji: '😟', label: 'Triste',     color: '#fbbf24' },
  critical:{ emoji: '🤒', label: 'Mal',        color: '#f87171' },
};

export function MoodBadge({ mood, size = 16 }) {
  const m = MOODS[mood] || MOODS.neutral;
  return <span title={m.label} style={{ fontSize: size }}>{m.emoji}</span>;
}

export function IntervalBadge({ interval }) {
  const color = INTERVAL_COLORS[interval] || '#94a3b8';
  return (
    <span style={{
      background: `${color}22`, color, border: `1px solid ${color}55`,
      borderRadius: 4, padding: '1px 7px', fontSize: 11, fontWeight: 700,
    }}>
      {interval}
    </span>
  );
}

export function Sparkline({ data, color = '#38bdf8', initialValue }) {
  if (!data || data.length < 2) {
    return <div style={{ height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span style={{ fontSize: 10, color: '#475569' }}>sem histórico</span>
    </div>;
  }
  return (
    <ResponsiveContainer width="100%" height={40}>
      <LineChart data={data} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
        <Line type="monotone" dataKey="value" stroke={color} dot={false} strokeWidth={1.5} />
        {initialValue && (
          <ReferenceLine y={initialValue} stroke="#334155" strokeDasharray="3 3" />
        )}
        <Tooltip
          contentStyle={{ background: '#0f172a', border: '1px solid #334155', fontSize: 10, padding: '2px 8px' }}
          formatter={(v) => [`$${v?.toLocaleString()}`, '']}
          labelFormatter={() => ''}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

// Baixa um objeto como arquivo JSON via download padrao do navegador.
export function downloadJson(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
